// extracted by mini-css-extract-plugin
export default {"suggestedField":"webpack-concepts-Extraction-Blocks-TextField-control-SuggestibleTextField-module__suggestedField"};